import script from "./OpsHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpsHome.vue?vue&type=script&setup=true&lang=ts"

import "./OpsHome.vue?vue&type=style&index=0&id=7c28c833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c28c833"]])

export default __exports__